import { useEffect, useState } from 'react';

import { grey60 } from 'constants/variables';
import { InfoIcon } from 'assets/icons';

import PaymentAccount from './payment_account';
import PaymentCard from './payment_card';
import PaymentPayPalButton from './payment_paypal_button';
import CEFMessage from '../cef_message/cef_message';

import warningIconRed from '../../../assets/images/shared/icons/warning-red.png';

const Payment = ({
  addressBook,
  addressEnquiryUrl,
  addressMode,
  assets,
  billingAddressUrl,
  branchAddressFlag,
  cashOnly,
  completeAccountOrderUrl,
  completeOrder,
  configGenericError,
  current_step: currentStep,
  customerInvoiceAddress,
  delivery_address: deliveryAddress,
  deliveryAddressUrl,
  display_errors: displayErrors,
  email,
  genericErrorConfig,
  getAddressBook,
  invoice_address: invoiceAddress,
  itsPaymentUrl,
  message,
  name,
  orderApprovalsEnabled,
  paymentOpen,
  paymentOptions: {
    account: accountPaymentsEnabled,
    its: itsEnabled,
    paypal: paypalEnabled,
  },
  paymentTotal,
  paypalPaymentUrl,
  processingState,
  setAddressFromAddressBook,
  setAddressMode,
  setInvoiceAddress,
  setInvoiceAddressFromAddressBook,
  setPaymentStatus,
  show_display_error: showDisplayError,
  showDetailErrors,
  signed_in: signedIn,
  step,
  summary,
  toggleGenericError,
}) => {
  const [paymentMethod, setPaymentMethod] = useState(
    signedIn ? (cashOnly ? 'CARD' : 'ACCOUNT') : 'CARD',
  );

  const handlePaymentMethodChange = method => {
    showDetailErrors(false, []);

    if (!processingState) {
      setPaymentMethod(!signedIn && method === 'ACCOUNT' ? 'CARD' : method);
    }
  };

  useEffect(() => {
    if (!signedIn) {
      handlePaymentMethodChange('CARD');
    } else {
      const newPaymentMethod =
        cashOnly || !accountPaymentsEnabled ? 'CARD' : 'ACCOUNT';
      handlePaymentMethodChange(newPaymentMethod);
    }
  }, [paymentOpen]);

  const {
    payment_details: {
      order_approval_payment_message: orderApprovalPaymentMessage,
      new_credit_account_message: newCreditAccountMessage,
    },
  } = summary;

  return (
    <div
      className={`checkout-panel payment-step payment-details-step ${
        currentStep !== 'PAYMENT' ? 'not-active' : ''
      }`}>
      <div className="checkout-header-title">
        <div className="checkout-header-title-left">
          <strong>{step}.</strong> Payment
        </div>
      </div>

      <div className="checkout-sub-panel payment">
        <div className={processingState ? ' disable-panel' : ''}>
          <h2>
            Payment Details{' '}
            <img src={assets.misc.secure} alt="" className="pull-right" />
          </h2>
          {message.global && (
            <CEFMessage
              icon={warningIconRed}
              text={message.global}
              classNames="cef-message--danger"
            />
          )}
          <p>
            <strong>Please select your payment type</strong>
          </p>
          <ul className="payment--options">
            {!cashOnly && accountPaymentsEnabled && (
              <li>
                <button
                  type="button"
                  className={`pay-on-account-option ${
                    paymentMethod === 'ACCOUNT' ? 'payment-selected' : ''
                  }${!signedIn ? ' hidden' : ''}`}
                  onClick={() => {
                    handlePaymentMethodChange('ACCOUNT');
                  }}>
                  Account
                </button>
              </li>
            )}

            {!orderApprovalsEnabled && (
              <>
                {itsEnabled && (
                  <li>
                    <button
                      type="button"
                      className={`pay-on-card-option ${
                        paymentMethod === 'CARD' ? 'payment-selected' : ''
                      }`}
                      onClick={() => {
                        handlePaymentMethodChange('CARD');
                      }}>
                      <img
                        src={assets.cards.card}
                        alt=""
                        className="card-payment"
                      />
                      <span>Credit / Debit Card</span>
                    </button>
                  </li>
                )}

                {paypalEnabled && (
                  <li>
                    <button
                      type="button"
                      className={`pay-by-paypal-option ${
                        paymentMethod === 'PAYPAL' ? 'payment-selected' : ''
                      }`}
                      onClick={() => {
                        handlePaymentMethodChange('PAYPAL');
                      }}>
                      <img
                        src={assets.cards.paypal}
                        alt="PayPal"
                        className="paypal-payment"
                      />
                    </button>
                  </li>
                )}
              </>
            )}
          </ul>
          {orderApprovalPaymentMessage && (
            <PaymentMethodMessage content={orderApprovalPaymentMessage} />
          )}
          {newCreditAccountMessage && (
            <PaymentMethodMessage content={newCreditAccountMessage} />
          )}
        </div>
      </div>

      {paymentMethod === 'ACCOUNT' && accountPaymentsEnabled && (
        <PaymentAccount
          paymentTotal={paymentTotal}
          completeAccountOrderUrl={completeAccountOrderUrl}
          completeOrder={completeOrder}
          setPaymentStatus={setPaymentStatus}
          showDetailErrors={showDetailErrors}
          showPaymentDisplayError={showDisplayError}
          paymentDisplayErrors={displayErrors}
          configGenericError={configGenericError}
          toggleGenericError={toggleGenericError}
        />
      )}
      {paymentMethod === 'CARD' && itsEnabled && !orderApprovalsEnabled && (
        <PaymentCard
          current_step={currentStep}
          delivery_address={deliveryAddress}
          setInvoiceAddress={setInvoiceAddress}
          addresses={addressBook}
          addressMode={addressMode}
          setAddressFromAddressBook={setAddressFromAddressBook}
          setInvoiceAddressFromAddressBook={setInvoiceAddressFromAddressBook}
          invoice_address={invoiceAddress}
          customerInvoiceAddress={customerInvoiceAddress}
          addressEnquiryUrl={addressEnquiryUrl}
          deliveryAddressUrl={deliveryAddressUrl}
          billingAddressUrl={billingAddressUrl}
          getAddressBook={getAddressBook}
          setAddressMode={setAddressMode}
          signed_in={signedIn}
          completeOrder={completeOrder}
          itsPaymentUrl={itsPaymentUrl}
          paymentTotal={paymentTotal}
          assets={assets}
          setPaymentStatus={setPaymentStatus}
          configGenericError={configGenericError}
          genericErrorConfig={genericErrorConfig}
          name={name}
          showDetailErrors={showDetailErrors}
          show_payment_display_error={showDisplayError}
          payment_display_errors={displayErrors}
          branchAddressFlag={branchAddressFlag}
          toggleGenericError={toggleGenericError}
        />
      )}
      {paymentMethod === 'PAYPAL' &&
        paypalEnabled &&
        !orderApprovalsEnabled && (
          <PaymentPayPalButton
            completeOrder={completeOrder}
            paypalPaymentUrl={paypalPaymentUrl}
            paymentTotal={paymentTotal}
            setPaymentStatus={setPaymentStatus}
            assets={assets}
            name={name}
            email={email}
            showDetailErrors={showDetailErrors}
            show_payment_display_error={showDisplayError}
            payment_display_errors={displayErrors}
            configGenericError={configGenericError}
            genericErrorConfig={genericErrorConfig}
            toggleGenericError={toggleGenericError}
          />
        )}
    </div>
  );
};

const PaymentMethodMessage = ({ content }) => (
  <div className="account-payment-method-message m-top-1rem">
    <InfoIcon fillColor={grey60} width={16} height={16} />
    <span className="ml-4">{content}</span>
  </div>
);

export default Payment;
